import React, {useState} from "react"
import VisibilitySensor from "react-visibility-sensor"

import {ApolloState} from "@irati/utils/services/apollo/apolloStateInterface"
import Loading from "@irati/ui/src/Loading"
import {List} from "@irati/utils/services/apollo/helpers/pagination"
import {FormattedMessage} from "@irati/utils/lang"
import {getDealList} from "@irati/deals/apollo/query/DealList"
import {hangPromise} from "@irati/utils/promise"

import NoExist from "./NoExist"
import ShowMoreButton from "./ShowMoreButton"

export type onNewPage = (isVisible: boolean, apollo: ApolloState) => any

interface Props {
  apollo: ApolloState
  onNewPage: onNewPage
  getList?: (apollo: ApolloState) => List
  hasDealFilterApplied: boolean
}

const ShowMoreOrThatsAll: React.FC<Props> = ({onNewPage, apollo, getList = getDealList, hasDealFilterApplied}) => {
  const [load, setLoad] = useState<Promise<any> | null>(null)

  const getLoad = () => {
    if (load) {
      return load
    } else if (!load && apollo.loading) {
      return hangPromise()
    }
    return null
  }

  const {results, limit = 9, hasMore} = getList(apollo)
  const thatsAll = !hasMore
  const showMoreButton = !thatsAll && !!results?.length && (results.length % (limit * 3) === 0)

  return (
    <>
      {!showMoreButton && (
        <VisibilitySensor partialVisibility onChange={(isVisible) => setLoad(onNewPage(isVisible, apollo))}>
          <div style={{height: 10}} />
        </VisibilitySensor>
      )}
      <Loading load={getLoad()}>
        {thatsAll && hasDealFilterApplied && !results.length ? (
          <NoExist>
            <FormattedMessage id="perks.components.dealList.notAvailableInRegion.body" />
          </NoExist>
        ) : showMoreButton ? (
          <ShowMoreButton onClick={() => setLoad(onNewPage(true, apollo))} />
        ) : (
          <NoExist />
        )}
      </Loading>
    </>
  )
}

export default ShowMoreOrThatsAll
